export function buildQueryString(query?: Record<string, any>): string {
    if (!query) return '';

    const params = new URLSearchParams();

    Object.entries(query).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;

        if (Array.isArray(value)) {
            value.forEach(v => { if (v) params.append(key, String(v)); });
        } else {
            params.append(key, String(value));
        }
    });

    const qs = params.toString();
    return qs ? `?${qs}` : '';
}
